import React, { ChangeEvent, useState } from 'react';
import { Styled } from '.';
import { CiFilter } from 'react-icons/ci';
import { AiOutlineClose } from 'react-icons/ai';
import { Checkbox } from 'components/core/Checkbox';
import { Button } from 'components/core';
import { useComponentVisible } from 'utils/hooks';
import { useI18n } from 'contexts/i18n';

const TableFilter = ({
  availableStatuses,
  selectedShipmentStatusFilters,
  setSelectedShipmentStatusFilters,
}: {
  availableStatuses: string[];
  selectedShipmentStatusFilters: string[];
  setSelectedShipmentStatusFilters: React.Dispatch<
    React.SetStateAction<string[]>
  >;
}) => {
  const [checkedStatuses, setCheckedStatuses] = useState<
    Record<string, boolean>
  >({});

  const findKeyListWithTrueValues = (obj: Record<string, boolean>) => {
    const keyList: string[] = [];
    for (const key in obj) {
      if (obj[key] === true) {
        keyList.push(key);
      }
    }
    return keyList;
  };
  const i18n = useI18n();
  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setCheckedStatuses(prevStatuses => ({ ...prevStatuses, [value]: checked }));
  };

  const {
    ref: filterRef,
    isComponentVisible: showFilterMenu,
    setIsComponentVisible: setShowFilterMenu,
  } = useComponentVisible(false);

  const filterButtonOnClick = () => {
    setShowFilterMenu(false);
    setSelectedShipmentStatusFilters(
      findKeyListWithTrueValues(checkedStatuses)
    );
  };

  const clearAllFilters = () => {
    setCheckedStatuses(previousValue => {
      const newCheckedStatuses = { ...previousValue };
      // set all statuses to false
      Object.keys(newCheckedStatuses).forEach(key => {
        newCheckedStatuses[key] = false;
      });
      return newCheckedStatuses;
    });

    // filterHandler();
  };

  return (
    <Styled.FilterWrapper ref={filterRef}>
      <Styled.FilterIconWrapper
        onClick={() => {
          setShowFilterMenu(!showFilterMenu);
        }}
      >
        <CiFilter size={25} />
      </Styled.FilterIconWrapper>
      {showFilterMenu ? (
        <Styled.FilterMenu>
          <Styled.FilterMenuHeader $spacer>
            <strong>{i18n['Filter by:']}</strong>
            <Styled.FilterMenuCloseButton
              onClick={() => setShowFilterMenu(false)}
            >
              <AiOutlineClose />
            </Styled.FilterMenuCloseButton>
          </Styled.FilterMenuHeader>
          <Styled.FilterMenuHeader>
            <strong>{i18n['Status:']}</strong>
          </Styled.FilterMenuHeader>
          <Styled.FilterStatusWrapper>
            {availableStatuses.map(status => {
              return status.toLowerCase() === 'all order' ? null : (
                <Checkbox
                  checked={checkedStatuses[status] || false}
                  value={status}
                  onChange={handleCheckboxChange}
                  label={i18n[`${status}`] ?? status}
                />
              );
            })}
          </Styled.FilterStatusWrapper>
          <Styled.FilterBottom $spacer>
            <Styled.FilterBottomClearAll onClick={clearAllFilters}>
              {i18n['Clear All']}
            </Styled.FilterBottomClearAll>
            <Button onClick={filterButtonOnClick}>{i18n['See Results']}</Button>
          </Styled.FilterBottom>
        </Styled.FilterMenu>
      ) : null}
    </Styled.FilterWrapper>
  );
};

export default TableFilter;
